<template>
  <SelectTableDialog
    title="引用委托加工合同创建入库单"
    ref="creatDialog"
    :searchColumns="searchColumns"
    :columnList="columnList"
    :defaultVisible="defaultVisible"
    :API="listOrderAPI"
    :extraData="extraData"
    propCode="contractNo"
    width="1200px"
    @close="close"
    @dblclickEvent="dblclickEvent"
    @confirm="confirm"
    @changeQuery="changeQuery"
  ></SelectTableDialog>
</template>

<script>
  /**
   * 外部按钮操作打开：(列表头部的按钮) 使用defaultVisible与 @close 监听弹窗开关
   * 内部按钮打开：插槽按钮，无需自行监听
   * 弹窗确认监听 @confirm
   * <SelectTableDialog>
   *  <button>按钮打开弹窗</button>
   * </SelectTableDialog>
   */
  import API from '@/api/wareHouse/supplierDeliveryOrder.js';
  import SelectTableDialog from '@/components/SelectTableDialog';
  // import COMPANY_API from '@/api/masterData/company';
  import BASEAPI from '@/api/dataBase.js';
  import { mapState } from 'vuex';
  export default {
    props: {},
    components: {
      SelectTableDialog,
    },
    data() {
      return {
        isMultiple: false,
        listOrderAPI: '', // 物流入库接口：暂无
        defaultVisible: false,
        extraData: {
          contractCategory: 'purchase',
          contractStatus: 'ZT03',
          contractDetailCategory: 'HT10',
        }, //搜索额外传参
        departmentList: [],
        query: {
          departmentCode: null,
        },
      };
    },
    mounted() {
      this.listOrderAPI = API.LIST_DETAIL;
      this.getDepartment(); //获取部门
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      searchColumns() {
        // const departmentUrl = this.companyCode
        //   ? `${COMPANY_API.GET_COMPANY_DETAIL_API}/${this.companyCode}`
        //   : '';
        return [
          {
            type: 'input',
            prop: 'contractNo',
            name: this.$t('supplierDeliveryOrder.creatDialog.search.contractNo'),
          },
          {
            type: 'input',
            prop: 'externalContractNo',
            name: this.$t('supplierDeliveryOrder.creatDialog.search.externalContractNo'),
          },
          {
            prop: 'productNo',
            name: this.$t('supplierDeliveryOrder.creatDialog.search.productNo'),
            type: 'searchTableSpec',
            searchType: 'goodsDetail',
            isMultiple: true,
            getSearchCode: 'productDetailCode', // 搜索时获取商品列表里面的哪个值作为查询条件
          },
          {
            prop: 'contractSalesmanNo', // 业务员
            name: this.$t('supplierDeliveryOrder.creatDialog.search.contractSalesmanNo'),
            type: 'searchTableSpec',
            searchType: 'personnel',
            isMultiple: true,
            getSearchCode: 'id',
          },
          {
            type: 'select',
            prop: 'contractBusinessDepartment',
            name: this.$t('supplierDeliveryOrder.creatDialog.search.contractBusinessDepartment'),
            clearable: true,
            options: this.departmentList,
          },
          {
            prop: 'supplierNo', // 供应商
            name: this.$t('supplierDeliveryOrder.creatDialog.search.supplierNo'),
            type: 'searchTableSpec',
            searchType: 'supplier',
            extraData: {
              companyCode: this.userInfo.companyCode,
              departmentCode: this.query.departmentCode,
            },
            isMultiple: true,
            getSearchCode: 'partnerCode',
          },
        ];
      },
      columnList() {
        return [
          {
            prop: 'contractNo',
            label: this.$t('supplierDeliveryOrder.creatDialog.table.contractNo'),
            width: 120,
            fixed: 'left',
          },
          {
            prop: 'externalContractNo',
            label: this.$t('supplierDeliveryOrder.creatDialog.table.externalContractNo'),
            width: 120,
          },
          {
            prop: 'supplierName',
            label: this.$t('supplierDeliveryOrder.creatDialog.table.supplierName'),
            width: 120,
          },
          {
            prop: 'storageName',
            label: this.$t('supplierDeliveryOrder.creatDialog.table.storageName'),
          },
          {
            prop: 'deliverTypeName',
            label: this.$t('supplierDeliveryOrder.creatDialog.table.deliverTypeName'),
          },
          {
            prop: 'productDesc',
            label: this.$t('supplierDeliveryOrder.creatDialog.table.productDesc'),
            width: 120,
          },
          {
            prop: 'unitName',
            label: this.$t('supplierDeliveryOrder.creatDialog.table.unit'),
            width: 120,
          },
          {
            prop: 'productQuantity',
            label: this.$t('supplierDeliveryOrder.creatDialog.table.productQuantity'),
            width: 120,
          },
          {
            prop: 'deliverableQuantity',
            label: this.$t('supplierDeliveryOrder.creatDialog.table.deliverableQuantity'),
            width: 120,
          },
          {
            prop: 'contractSalesmanName',
            label: this.$t('supplierDeliveryOrder.creatDialog.table.contractSalesmanName'),
            width: 120,
          },
          {
            prop: 'contractBusinessDepartmentName',
            label: this.$t(
              'supplierDeliveryOrder.creatDialog.table.contractBusinessDepartmentName'
            ),
            width: 120,
          },
          {
            prop: 'companyName',
            label: this.$t('supplierDeliveryOrder.creatDialog.table.companyName'),
            width: 120,
          },
        ];
      },
    },
    methods: {
      changeQuery(obj) {
        this.query.departmentCode = obj.contractBusinessDepartment;
      },
      //获取部门
      async getDepartment() {
        const selectStatus = await this.$axios.post(
          BASEAPI.LIST_DEPARTMENT_API + `/${this.userInfo.companyCode}`
        );
        this.departmentList = selectStatus.data.data;
      },
      //双击选择
      dblclickEvent(selections) {
        console.log(selections);
      },
      // 弹窗确认
      confirm(selections) {
        console.log(selections);
        if (selections.length == 0) {
          this.$message({
            showClose: true,
            message: this.$t('mcInboundList.msg.createSalesGoods'),
            type: 'error',
          });
          return;
        } else if (selections.length > 1) {
          this.$message({
            showClose: true,
            message: this.$t('mcInboundList.msg.createSingleGoods'),
            type: 'error',
          });
          return;
        } else {
          let path = {
            path: '/wareHouse/mcInboundAdd',
            name: 'mcInboundAdd',
            meta: {
              keepAlive: true,
              title: '新建委托加工入库单',
            },
            query: {
              isEdit: 'Y',
              contractNo: selections[0].contractNo,
              contractDetailNo: selections[0].contractDetailNo,
            },
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
          this.close();
        }
      },
      // 弹窗关闭
      close() {
        this.defaultVisible = false;
      },
    },
  };
</script>
